/* BDS umbrella configurator - CFM-accurate options, availability and reasons.
 * Draft theme: "New product- Umbrella, flags, etc.. migration".
 * Adds the option group CFM actually sells that our pages are missing
 * (Canopy Fabric), and marks every combination CFM cannot make as
 * unavailable with the reason written out in plain English.
 * It never changes a price and never enables a build that has no variant. */
(function () {
  'use strict';
  if (window.__BDS_UMBRELLA_FIT__) return;

  var DATA = null;
  try {
    var el = document.getElementById('bds-umbrella-data');
    if (!el) return;
    DATA = JSON.parse(el.textContent);
  } catch (e) { return; }
  if (!DATA || !DATA.handle || !DATA.model) return;

  var MODEL = DATA.model;
  var FAB = MODEL.fabrics || [];
  if (!FAB.length) return;

  var FABRIC_LABEL = 'Choose Canopy Fabric';

  var STD_FABRIC = FAB[0];
  var STD_TAT = '72H'; /* what we buy at; not offered as a choice */

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function nativeSelects() {
    return $$('select[data-variant-option]').filter(function (s) {
      return s.closest('.config-cell');
    });
  }

  function findSelectByValues(values) {
    var want = values.map(function (v) { return v.toLowerCase(); });
    var hit = null;
    nativeSelects().forEach(function (s) {
      if (hit) return;
      var have = $$('option', s).map(function (o) { return (o.value || '').toLowerCase(); });
      var all = want.every(function (w) { return have.indexOf(w) >= 0; });
      if (all) hit = s;
    });
    return hit;
  }

  /* The three option groups that already exist on our umbrella pages. */
  var selPrint = findSelectByValues(['single side graphic printed', 'double side graphics printed']);
  var selFrame = findSelectByValues(['with pole', 'without pole']);
  var selBase = findSelectByValues(['no base', 'round metal base']);

  /* Fail safe: if the page is not shaped the way we expect, do nothing at all. */
  if (!selFrame || !selBase) return;

  /* ---------- build the missing option cell ---------- */
  function buildCell(templateCell, headingText, id, options, preselect) {
    var cell = templateCell.cloneNode(true);
    cell.setAttribute('data-bds-umb-cell', id);

    var h3 = $('h3', cell);
    if (h3) {
      var kept = null;
      Array.prototype.slice.call(h3.childNodes).forEach(function (n) {
        if (n.nodeType === 1 && n.tagName.toLowerCase() === 'svg' && !kept) { kept = n; return; }
        h3.removeChild(n);
      });
      h3.appendChild(document.createTextNode(' ' + headingText + ' '));
    }

    var old = $('select', cell);
    if (!old) return null;
    var sel = document.createElement('select');
    sel.id = 'bds-umb-' + id;
    sel.setAttribute('data-bds-umb', id);
    sel.className = old.className;
    var want = (preselect && options.indexOf(preselect) >= 0) ? preselect : options[0];
    options.forEach(function (o) {
      var op = document.createElement('option');
      op.value = o;
      op.textContent = o;
      if (o === want) op.selected = true;
      sel.appendChild(op);
    });
    sel.value = want;
    old.parentNode.replaceChild(sel, old);
    return cell;
  }

  var row = selFrame.closest('.config-row') || selFrame.closest('.config-container');
  var templateCell = selFrame.closest('.config-cell');
  if (!row || !templateCell) return;

  var ownRow = document.createElement('div');
  ownRow.className = row.className;
  ownRow.setAttribute('data-bds-umb-row', '1');

  /* Production time is deliberately not offered on the storefront: we buy at
   * the standard lead time and do not sell the faster options. */
  var fabricCell = buildCell(templateCell, FABRIC_LABEL, 'fabric', FAB, STD_FABRIC);
  if (!fabricCell) return;
  ownRow.appendChild(fabricCell);
  if (row.parentNode) row.parentNode.insertBefore(ownRow, row.nextSibling);

  var selFabric = $('select[data-bds-umb="fabric"]', ownRow);

  /* ---------- notice ---------- */
  var notice = document.createElement('div');
  notice.id = 'bds-umbrella-notice';
  notice.setAttribute('role', 'status');
  notice.style.cssText = 'margin:12px 0;padding:12px 14px;border:1px solid #E6B800;background:#FFF8E1;' +
    'border-radius:8px;font-size:14px;line-height:1.45;color:#5C4500;display:none;';
  (ownRow.parentNode || document.body).insertBefore(notice, ownRow.nextSibling);

  function showNotice(html) { notice.innerHTML = html; notice.style.display = 'block'; }
  function hideNotice() { notice.innerHTML = ''; notice.style.display = 'none'; }

  function listOut(arr) {
    if (arr.length === 1) return arr[0];
    return arr.slice(0, -1).join(', ') + ' or ' + arr[arr.length - 1];
  }

  /* ---------- the CFM rules ---------- */
  /* Returns null when the build is fine, or {title, detail} when it is not. */
  function checkCFM(state) {
    if (state.print && /double side/i.test(state.print)) {
      return {
        title: 'Double-sided printing isn’t made for umbrellas.',
        detail: 'The canopy is printed on the outer face only. Choose <b>Single side graphic printed</b> to continue.'
      };
    }
    if (FAB.indexOf(state.fabric) < 0) {
      return {
        title: state.fabric + ' isn’t available on this umbrella.',
        detail: 'This size is made in: ' + listOut(FAB) + '.'
      };
    }
    return null;
  }

  /* ---------- variant resolution ---------- */
  var VARIANTS = DATA.variants || [];
  function currentVariant() {
    var want = {};
    nativeSelects().forEach(function (s) {
      want[String(s.getAttribute('data-variant-option'))] = s.value;
    });
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i], ok = true;
      for (var k = 0; k < v.options.length; k++) {
        if (want[String(k)] !== undefined && want[String(k)] !== v.options[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Only the standard fabric has a real variant behind it today, so only that
   * build can be ordered online. Any other fabric is a quote request. */
  function isStandardBuild(state) {
    return state.fabric === STD_FABRIC;
  }

  /* ---------- button handling ---------- */
  var btn = $('.add-to-cart-button') || $('button[name="add"]');
  var btnOriginalText = btn ? btn.innerHTML : '';
  var blockedByUs = false;

  function blockButton(label) {
    if (!btn) return;
    blockedByUs = true;
    btn.setAttribute('data-bds-umb-blocked', '1');
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.style.opacity = '0.55';
    btn.style.cursor = 'not-allowed';
    if (label) btn.textContent = label;
  }

  function releaseButton() {
    if (!btn || !blockedByUs) return;
    blockedByUs = false;
    btn.removeAttribute('data-bds-umb-blocked');
    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    btn.style.opacity = '';
    btn.style.cursor = '';
    btn.innerHTML = btnOriginalText;
  }

  /* Never let a blocked build reach the cart, whatever else is on the page. */
  document.addEventListener('click', function (ev) {
    if (!btn || !blockedByUs) return;
    if (ev.target === btn || (ev.target.closest && ev.target.closest('.add-to-cart-button') === btn)) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }, true);

  document.addEventListener('submit', function (ev) {
    if (!blockedByUs) return;
    var f = ev.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }, true);

  /* ---------- state + render ---------- */
  function readState() {
    return {
      print: selPrint ? selPrint.value : '',
      frame: selFrame ? selFrame.value : '',
      base: selBase ? selBase.value : '',
      fabric: selFabric ? selFabric.value : STD_FABRIC,
      tat: STD_TAT
    };
  }

  /* Grey out the options CFM does not make, so they read as unavailable
   * before the shopper even picks them. */
  function markUnsellableOptions() {
    if (selPrint) {
      $$('option', selPrint).forEach(function (o) {
        if (/double side/i.test(o.value)) {
          o.disabled = true;
          if (!/unavailable/i.test(o.textContent)) o.textContent = o.textContent.trim() + ' — unavailable';
        }
      });
    }
  }

  function render() {
    var st = readState();
    var problem = checkCFM(st);

    if (problem) {
      showNotice('<strong>' + problem.title + '</strong><br>' + problem.detail);
      blockButton('Not available');
      return;
    }

    if (!isStandardBuild(st)) {
      showNotice(
        '<strong>' + st.fabric + ' is made, but not set up for instant checkout yet.</strong><br>' +
        'The standard canopy (' + STD_FABRIC + ') orders online right away. ' +
        'For this fabric, use <b>Request Custom Size Quote</b> above and we will price it from the factory.'
      );
      blockButton('Request a quote');
      return;
    }

    var v = currentVariant();
    if (v && v.available === false) {
      showNotice('<strong>This combination is sold out.</strong><br>Please choose a different hardware or base option.');
      return;
    }

    hideNotice();
    releaseButton();
  }

  /* ---------- wire up ---------- */
  markUnsellableOptions();
  [selPrint, selFrame, selBase, selFabric].forEach(function (s) {
    if (!s) return;
    s.addEventListener('change', render);
    s.addEventListener('input', render);
  });

  var mo = new MutationObserver(function () {
    if (!document.getElementById('bds-umbrella-notice')) return;
    render();
  });
  try {
    var host = $('.config-container');
    if (host) mo.observe(host, { subtree: true, attributes: true, attributeFilter: ['value', 'selected'] });
  } catch (e) {}

  window.__BDS_UMBRELLA_FIT__ = {
    version: 1,
    handle: DATA.handle,
    fabrics: FAB,
    state: readState,
    render: render
  };
  render();
})();